import { useEffect, useState } from "react";
import { API, TOKEN_KEY } from "@/lib/api";

export default function AuthImage({ photoId, alt = "", className = "" }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    setSrc(`${API}/photos/${photoId}?auth=${encodeURIComponent(token || "")}`);
  }, [photoId]);
  return <img src={src} alt={alt} className={className} loading="lazy" />;
}
